export const DEVICE_STORAGE_KEY = 'cobstream:device';

/**
 * A stable per-browser device id, minted once and persisted in localStorage.
 * Sent as the `x-cobstream-device` header on every playback-start request so
 * the backend screen registry can enforce concurrent-device limits. Distinct
 * from `cobstream:profile.localId` (guest identity) — this survives sign-in.
 */
export function getDeviceId(): string {
  if (typeof window === 'undefined') return 'ssr';
  try {
    const existing = window.localStorage.getItem(DEVICE_STORAGE_KEY);
    if (existing) return existing;
  } catch {
    /* storage may be unavailable */
  }
  const fresh = mint();
  try {
    window.localStorage.setItem(DEVICE_STORAGE_KEY, fresh);
  } catch {
    /* ignore */
  }
  return fresh;
}

function mint(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const b = new Uint8Array(16);
    crypto.getRandomValues(b);
    return Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 18)}`;
}
